import React, { useState } from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: "Tracey A.",
    type: "Bungee",
    quote: "I was desperately looking for a cardio opportunity that would also be fun. Flying is easy on my knees, protects my back and when we're done, I can't believe how many calories I've burned. Give yourself the **gift of flying**… it is good for your **body, heart and soul**!!!",
    highlight: "Good for your body, heart and soul"
  },
  {
    id: 2,
    name: "Crystal K.",
    type: "Bungee",
    quote: "I've gained so much confidence pushing myself out of my comfort zone and discovering **my body can do things I never thought possible**. If you want cardio that genuinely **doesn't feel like cardio**, this is it. It's playful, empowering, and addictive in the best way.",
    highlight: "Cardio that doesn't feel like cardio"
  },
  {
    id: 3,
    name: "Claudia S.",
    type: "Bungee",
    quote: "I'm **75** and it was a whole new adventure in exercise. Cal and Crystal were great at demonstrating and so encouraging. **Cannot wait to go back!**",
    highlight: "75 and a whole new adventure"
  },
  {
    id: 4,
    name: "Meghan D.",
    type: "Aerial Kids",
    quote: "We ditched soccer camp for it and hands down it was the **best decision**. Cal has a gift for **empowering children**, encouraging them to believe in themselves, and making every student feel **seen and supported**.",
    highlight: "Empowering children to believe in themselves"
  },
  {
    id: 5,
    name: "Adele M.",
    type: "Aerial Kids",
    quote: "The absolute best part for me was the clear **sense of pride my daughter experienced** in her achievements of strength. To witness how proud she was of herself was truly **priceless**! I cannot wait to witness my daughter's strength and spirit **FLY**!",
    highlight: "Watching her strength and spirit fly"
  },
  {
    id: 6,
    name: "Lauren G.",
    type: "Aerial Kids",
    quote: "My daughter had the opportunity to try **several different forms of aerial arts**. They even spent time on stand up paddle boards and had a STEM experience at iFLY! Cal did a great job at **getting the kids excited** about their day. I will **definitely sign up again**!",
    highlight: "Getting the kids excited"
  }
];

const TestimonialsSection = () => {
  const [filter, setFilter] = useState('all');

  const filteredTestimonials = filter === 'all' 
    ? testimonials 
    : testimonials.filter(t => t.type.toLowerCase().includes(filter));

  const renderQuote = (quote) => {
    // Convert **text** to bold
    const parts = quote.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => 
      index % 2 === 1 ? <strong key={index}>{part}</strong> : part
    );
  };

  return (
    <section className="testimonials-section">
      <div className="testimonials-header">
        <span className="section-label">Real People, Real Results</span>
        <h2>Here's what happens when people show up.</h2>
        <p>All 5-star Google reviews from our community</p>
      </div>

      <div className="testimonials-filters">
        <button 
          className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          All
        </button>
        <button 
          className={`filter-btn ${filter === 'bungee' ? 'active' : ''}`}
          onClick={() => setFilter('bungee')}
        >
          Bungee
        </button>
        <button 
          className={`filter-btn ${filter === 'aerial' ? 'active' : ''}`}
          onClick={() => setFilter('aerial')}
        >
          Aerial Kids
        </button>
      </div>

      {/* Simple grid - always shows ALL filtered reviews */}
      <div className="testimonials-grid">
        {filteredTestimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="testimonial-stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} fill="#FFC914" color="#FFC914" />
              ))}
            </div>
            <Quote className="quote-icon" size={32} />
            <p className="testimonial-quote">{renderQuote(testimonial.quote)}</p>
            <div className="testimonial-author">
              <span className="author-name">{testimonial.name}</span>
              <span className="author-type">{testimonial.type}</span>
            </div>
          </div>
        ))}
      </div>

      <a 
        href="https://maps.app.goo.gl/k3Y8fNyMx7WpGWUM6" 
        target="_blank" 
        rel="noopener noreferrer"
        className="google-reviews-link"
      >
        See all reviews on Google
      </a>
    </section>
  );
};

export default TestimonialsSection;
